/** @format */

import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import Navbar from "../Navbar";
// import { SecureRoute } from "@okta/okta-react";
import { Route, Navigate, Routes } from "react-router-dom";
import { pagesList, AdditionPages } from "../RouterWithAcess/routes";
import useRoles from "../../hooks/useRoles";
import useGetRegions from "../../hooks/useRegions";
import useGetChannels from "../../hooks/useChannels";
import NotFound from "../common/NotFound";
const SecureRoute = ({ children }) => {
  const { authState } = useOktaAuth();
  if (!authState) return null;
  return authState.isAuthenticated ? children : <Navigate to='/login' />;
};

const Landing = (props) => {
  // const [state, setState] = useState({
  //   authenticated: null,
  // });
  const {
    isTokenDecoded,
    currentUserName,
    currentUserEmail,
    isSuperAdminRole,
    isAdminRole,
    isEdibleOilsRole,
    isCocoaRole,
    isAnimalFeedRole,
    isGrainsRole,
    isCornRole,
    groups,
  } = useRoles();
  useGetRegions();
  useGetChannels();
  // eslint-disable-next-line
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    oktaAuth.tokenManager.on("expired", () => {
      console.info("EXPIRED CALLED");
      oktaAuth.signOut();
    });
  }, [oktaAuth]);

  const logout = async () => {
    oktaAuth.signOut();
    // localStorage.removeItem("okta-cache-storage");
    // localStorage.removeItem("okta-token-storage");
    // window.sessionStorage.clear();
    // window.sessionStorage.removeItem("accessToken");
    // window.location.replace("/LogIn");
  };

  // const { currentUserEmail, currentUserName } = state;
  // const mainContent = state.authenticated ? (
  //   <div>
  //     <button className="btn btn-light btn-lg" onClick={logout}>
  //       Logout
  //     </button>
  //   </div>
  // ) : (
  //   <div></div>
  // );

  if (isTokenDecoded && isSuperAdminRole === false && isAdminRole === false) {
    setTimeout(() => logout(), 3000);
    return (
      <div>
        User is not authenticated to login{" "}
        <a href='/' onClick={() => logout()}>
          Logout
        </a>
      </div>
    );
  } else if (isSuperAdminRole || isAdminRole) {
    return (
      <div>
        <Navbar
          currentUserName={currentUserName}
          logout={logout}
          email={currentUserEmail}
          isAdminRole={isAdminRole}
          isCocoaRole={isCocoaRole}
          isGrainsRole={isGrainsRole}
          isCornRole={isCornRole}
          isAnimalFeedRole={isAnimalFeedRole}
          isEdibleOilsRole={isEdibleOilsRole}
          isSuperAdminRole={isSuperAdminRole}
          groups={groups}
        />
        <Routes>
          {pagesList
            .filter((page) => page.roles(Array.isArray(groups) ? groups : []))
            .map((page, index) => {
              const isAuthorized = page.permissions(Array.isArray(groups) ? groups : []);
              return (
                <Route
                  path={page.pageLink}
                  caseSensitive={page.isExact}
                  element={
                    <SecureRoute>
                      {!isAuthorized ? (
                        <div className='main-box'>
                          <div className='grid' style={{ paddingTop: "100px" }}>
                            <h2>User Not authorized to view</h2>
                          </div>
                        </div>
                      ) : (
                        <page.view
                          Name={currentUserName}
                          email={currentUserEmail}
                          isAdminRole={isAdminRole}
                          isCocoaRole={isCocoaRole}
                          isGrainsRole={isGrainsRole}
                          isCornRole={isCornRole}
                          isAnimalFeedRole={isAnimalFeedRole}
                          isEdibleOilsRole={isEdibleOilsRole}
                          isSuperAdminRole={isSuperAdminRole}
                          groups={groups}
                        />
                      )}
                    </SecureRoute>
                  }
                  key={index}
                  errorElement={<div>Error</div>}
                />
              );
            })}
          {AdditionPages.map((page, index) => (
            <Route
              key={index}
              path={page.pageLink}
              caseSensitive={page.isExact}
              element={
                <SecureRoute>
                  <page.view />
                </SecureRoute>
              }
              errorElement={<div>Error</div>}
            />
            // <SecureRoute exact path={page.pageLink} component={page.view} key={index} />
          ))}
          <Route path='*' Component={NotFound} />
        </Routes>
      </div>
    );
  } else {
    return <div>Loading...</div>;
  }
};

export default Landing;
